import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, Params } from '@angular/router';

import { CitGlobalConstantService } from './core/cit-global-constants.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {

  public AVEVALogoURL: string;
  public AVEVALogoAltURL: string;
  public title = 'Citect License Generator';
  public year: number;

  constructor(private router: Router,
    public citGlobalConstantService: CitGlobalConstantService) {
    this.AVEVALogoURL = this.citGlobalConstantService.AVEVALogoURL;
    this.AVEVALogoAltURL = this.citGlobalConstantService.AVEVALogoAltURL;
    this.year = Date.now();
  }
  navigateToHomePage() {
      this.router.navigate(['']);
  }

}
